import { useNavigate } from 'react-router-dom'
import { useGmoPayment } from '@!/components/CreditCard/hooks/useGmoPayment'
import { usePaymentValidation } from '@!/User/Payment/Hooks/usePaymentValidation'
import NewCardView from '@!/User/Payment/components/NewCard'

export const PaymentNewCard = () => {
  usePaymentValidation()

  const navigate = useNavigate()
  const { handleGetGmoToken } = useGmoPayment()

  const onSubmit = async (data, setError) => {
    const result = await handleGetGmoToken(data, setError)
    if (result.success) {
      navigate('/confirm')
    }
  }

  const pageBack = (e) => {
    e.preventDefault()
    navigate(-1)
  }

  return <NewCardView onSubmit={onSubmit} pageBack={pageBack} />
}

export default PaymentNewCard
